import { Component } from 'react';
import { Spinner } from '@chakra-ui/react';
import LotteryContainer from './LotteryContainer';

export default class Loading extends Component {
  render() {
    return <LotteryContainer showName='Loading...' hideImage><Spinner /></LotteryContainer>;
  }
}